import React             from 'react';
import { Redirect }      from 'react-router-dom';
import QualificationList from './QualificationList';
import Qualification     from './Qualification';

export const QualificationConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path      : '/qualification/:view_type/:qualification_id',
            component : Qualification,
            permission: { component_name: 'qualification', permission_type: 'view_type' },
        },
        {
            path      : '/qualification/list',
            component : QualificationList,
            permission: { component_name: 'qualification', permission_type: 'list' },
        },
        {
            path      : '/qualification/:view_type/',
            component : Qualification,
            permission: { component_name: 'qualification', permission_type: 'view_type' },
        },
        {
            path      : '/qualification',
            component : () => <Redirect to="/qualification/list" />,
            permission: { component_name: 'qualification', permission_type: 'list' },
        }
    ]
};



// WEBPACK FOOTER //
// src/main/content/qualification/QualificationConfig.js